export default {

  namespaced: true,

  state: () => ({


  }),

  mutations: {

  },

  actions: {

    async download({ commit }, params){
console.log(params)
      const data = await axios({
        url: "/erp/invoice/download-xml",
        method: "GET",
        responseType: "blob",
        params: params
      });

      return data;

    }

  }
}
